import Slider from 'rc-slider';
import styles from './DatastoreScalingStep2.module.less';
import { SliderMarks } from 'antd/lib/slider';
import 'rc-slider/assets/index.css';
import { Alert, Col, Row, message } from 'antd';
import DatastoreScalingStepHeader from './DatastoreScalingStepHeader';
import DatastoreScalingCard from './DatastoreScalingCard';
import DatastoreScalingNodeInfoCard from './DatastoreScalingNodeInfoCard';
import DeploymentsItem from '../../../types/DeploymentsItem';
import Service from '../../../types/Service';
import { FormInstance } from 'antd/es';
import DeploymentOptions from '../../../types/DeploymentOptions';
import { useEffect, useState } from 'react';

interface DataStoreScalingStep2Props {
    dataStore: DeploymentsItem;
    services: any;
    countryCode: string | undefined;
    form: FormInstance;
    checkedValues: string[];
    setCheckedValues: Function;
    newNodeData: any[];
    setNewNodeData: Function;
    deploymentOptions: DeploymentOptions;
    nodeValue: number;
    setNodeValue: Function;
}
export default function DatastoreScalingStep2({
    dataStore,
    services,
    countryCode,
    form,
    newNodeData,
    setNewNodeData,
    checkedValues,
    setCheckedValues,
    deploymentOptions,
    nodeValue,
    setNodeValue,
}: DataStoreScalingStep2Props) {
    const handleNodeChange = (e: number | number[]) => {
        if (['Galera', 'Redis'].includes(dataStore?.getClusterType())) {
            // Calculate the delta (change) in the number of nodes
            const delta = Array.isArray(e) ? e[0] - nodeValue : e - nodeValue;
            // Check if the delta is not a multiple of 40
            if (delta % 40 !== 0) {
                return;
            }
            const nextValue = nodeValue + delta;

            // Ensure the nextValue is within the valid range
            const minNodes = 1;
            const maxNodes = 5;
            const clampedNextValue = Math.max(
                minNodes * 20,
                Math.min(maxNodes * 20, nextValue)
            );

            setNodeValue(clampedNextValue);
        } else {
            setNodeValue(e);
        }
    };

    let marks: SliderMarks = {
        20: '1 Node',
        40: '2 Nodes',
        60: '3 Nodes',
        80: '4 Nodes',
        100: '5 Nodes',
    };
    if (dataStore) {
        const currentConfigLabel = `${services?.dbServices?.length} Nodes`;
        const dynamicMarks = {
            ...marks,
            [services?.dbServices?.length * 20]: {
                label: (
                    <p>
                        <p style={{ marginBottom: 0 }}>{currentConfigLabel}</p>
                        <p>(current configuration)</p>
                    </p>
                ),
            },
        };
        marks = dynamicMarks;
    }

    return (
        <>
            {['Galera', 'Redis'].includes(dataStore?.getClusterType()) && (
                <Alert
                    className={styles.DatastoreScalingStep2Alert}
                    message={`For the cluster type "${dataStore?.getClusterType()}" you can only scale up/down by 2 nodes`}
                    showIcon
                    type="info"
                />
            )}
            <DatastoreScalingStepHeader
                title="Datastore configuration"
                subtitle="Use the slider to set the desired amount of nodes"
            >
                <Row className={styles.DatastoreScalingStep2SliderRow}>
                    <Col span={20}>
                        <Slider
                            marks={marks}
                            defaultValue={nodeValue}
                            value={nodeValue}
                            trackStyle={{ backgroundColor: '#C41D7F' }}
                            railStyle={{ backgroundColor: '#F5F5F5' }}
                            handleStyle={{ backgroundColor: 'white' }}
                            onChange={(e) => handleNodeChange(e)}
                            step={20}
                            min={20}
                        />
                    </Col>
                </Row>
                <DatastoreScalingCard
                    stepScalingTitle="Configuration: "
                    stepScalingCount={`${nodeValue ? nodeValue / 20 : 0} Node`}
                />
                <Row
                    gutter={[24, 24]}
                    className={styles.DatastoreScalingStep2NodeInfo}
                >
                    {nodeValue && nodeValue / 20 >= services?.dbServices?.length
                        ? Array.from({ length: nodeValue / 20 }, (_, index) => (
                              <>
                                  {index === services?.dbServices?.length &&
                                      dataStore &&
                                      services?.dbServices?.length % 2 !==
                                          0 && (
                                          <div
                                              className={
                                                  styles.DatastoreScalingNewNode
                                              }
                                          ></div>
                                      )}
                                  <DatastoreScalingNodeInfoCard
                                      key={index}
                                      index={index}
                                      datastore={dataStore}
                                      services={services}
                                      countryCode={countryCode}
                                      checkedValues={checkedValues}
                                      setCheckedValues={setCheckedValues}
                                      nodeValue={nodeValue}
                                      form={form}
                                      setNewNodeData={setNewNodeData}
                                      newNodeData={newNodeData}
                                      deploymentOptions={deploymentOptions}
                                  />
                              </>
                          ))
                        : Array.from(
                              { length: services?.dbServices?.length },
                              (_, index) => (
                                  <DatastoreScalingNodeInfoCard
                                      key={index}
                                      index={index}
                                      datastore={dataStore}
                                      services={services}
                                      countryCode={countryCode}
                                      checkedValues={checkedValues}
                                      setCheckedValues={setCheckedValues}
                                      nodeValue={nodeValue}
                                      form={form}
                                      setNewNodeData={setNewNodeData}
                                      newNodeData={newNodeData}
                                      deploymentOptions={deploymentOptions}
                                  />
                              )
                          )}
                </Row>
            </DatastoreScalingStepHeader>
        </>
    );
}
